import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Footer from "../../../../components/Footer/Footer";
import "../styles/PolicyPage.css";
import usePolicy from "../hooks/usePolicyData";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import { capitalize } from "../../../../utils/text.utils";

import PolicySection from "../components/PolicySection";
import PolicySkeleton from "../components/PolicySkeleton";
import { useEffect } from "react";

export default function PolicyPage() {
  const { page_slug } = useParams();
  const { policy, loading, error } = usePolicy(page_slug);
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      navigate("/error/404", { replace: true });
    }
  }, [error, navigate]);

  return (
    <>
      {!loading && policy?.title && (
        <Breadcrumbs
          paths={[
            {
              label: capitalize(policy.title),
              to: "",
            },
          ]}
        />
      )}

      <div className="terms-page">
        <div className="terms-container">
          {loading ? (
            <PolicySkeleton />
          ) : (
            <>
              <h1 className="terms-title">{policy?.title}</h1>

              {/* PREAMBLE */}
              {policy?.preamble?.map((text) => (
                <p
                  key={text.slice(0, 20)}
                  className="terms-text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              ))}

              {/* SECTIONS */}
              {policy?.sections?.map((section) => (
                <PolicySection
                  key={section.section}
                  section={section}
                />
              ))}
            </>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}
